module.exports = __webpack_public_path__ + "media/images/regional-image5-ee2f39f131708b89781dd828cdc7947e.jpg";